<footer class="footer">
  <div class="container-wide">

    <div class="footer-top-grid">

      <!-- Brand & Socials -->
      <div class="footer-brand-col">
        <a href="#home" class="footer-logo-link">
          <img src="/Ambition_built_logo.png" alt="Ambition Built Luxury Architectural Homes" class="footer-brand-logo">
        </a>

        <p class="tagline">Our Ambition is Your Future.</p>

        <div class="social-links">
          <a href="https://instagram.com" target="_blank" aria-label="Instagram">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
            </svg>
          </a>
          <a href="https://facebook.com" target="_blank" aria-label="Facebook">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
            </svg>
          </a>
        </div>
      </div>

      <!-- Explore Links -->
      <div class="footer-col">
        <h4 class="col-title">EXPLORE</h4>
        <ul class="link-list">
          <li><a href="#home">Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#projects">Projects</a></li>
          <li><a href="#process">Our Process</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </div>

      <!-- Services Links -->
      <div class="footer-col">
        <h4 class="col-title">SERVICES</h4>
        <ul class="link-list">
          <li><a href="#services">Custom New Homes</a></li>
          <li><a href="#services">Knock Down & Rebuild</a></li>
          <li><a href="#services">Duplex Designs</a></li>
        </ul>
      </div>

      <!-- Contact Info & Credentials -->
      <div class="footer-col">
        <h4 class="col-title">CONTACT</h4>
        <ul class="contact-info-list">
          <li>Sydney, NSW</li>
          <!-- <li><a href="tel:0412345678">0412 345 678</a></li> -->
          <li><a href="mailto:info@ambitionbuilt.com.au">info&#64;ambitionbuilt.com.au</a></li>
        </ul>

        <!-- <div class="license-box">
          <div class="lic-line">Builder License: 334805C</div>
          <div class="lic-line">ABN: 93 612 054 802</div>
        </div> -->
      </div>

    </div>

    <div class="footer-bottom-bar">
      <div class="copy-text">
        © Ambition Built {{ currentYear }}. All Rights Reserved.
      </div>
      <div class="bottom-links">
        <a href="#home">Privacy Policy</a>
        <span class="dot">•</span>
        <a href="#home">Terms & Conditions</a>
      </div>
    </div>

  </div>
</footer>